import React, { useState, useEffect } from 'react';
import "./BackToTop.scss";
import ArrowUp from '../../../assets/icons/ArrowUp';
import { useLocation } from 'react-router-dom';

const BackToTopButton = () => {
    const [isVisible, setIsVisible] = useState(false);

    const location = useLocation();
    const pathname = location.pathname !== '/admin/campaign';


    // Show button when page is scrolled down
    const toggleVisibility = () => {
        if (window.pageYOffset > 300) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    // Scroll to top
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    useEffect(() => {
        window.addEventListener('scroll', toggleVisibility);
        return () => {
            window.removeEventListener('scroll', toggleVisibility);
        };
    }, []);

    return (
        <div className="back-to-top">
            {(pathname && isVisible) && (
                <button onClick={scrollToTop} className="back-to-top-button">
                    <ArrowUp className={"icon"} />
                </button>
            )}
        </div>
    );
};

export default BackToTopButton;
